/**
 * O componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el = $(el);
const $input = $el.find('input');
const $boxInput = $el.find('.box-input');

$input.on('keyup blur', function() {
    if( $(this).val() ) {
        $boxInput.addClass('full');
    } else  {
        $boxInput.removeClass('full');
    }
}).trigger('keyup');
